import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Tooltip, WireframeIcon } from '@frontend/components';

import { wireFrameTool } from 'modules/common/viewer/cadViewer/data/actions';
import { getIsWireFrameToolActive } from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const WireFrameTool = ({
  isEnabled, // passed in as direct prop
}) => {
  const isActive = useSelector(getIsWireFrameToolActive);
  const dispatch = useDispatch();
  const toggleWireFrameTool = useCallback(() => {
    dispatch(wireFrameTool.toggle());
  }, [dispatch]);

  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        <ViewerButtonTooltip
          firstLine="Wireframe view"
          secondLine="Focused bodies"
        />
      }
    >
      <ViewerButton
        isActive={isActive}
        aria-label="Wireframe view"
        onClick={toggleWireFrameTool}
      >
        <WireframeIcon boxSize={3} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default WireFrameTool;
